import { useState, useEffect } from 'react';
import { SendMessage } from './App.js';
import icobackblue from './img/ico-backblue.svg';
import iconextsong from './img/ico-nextsong.svg';
import icoreplay from './img/ico-replay.svg';
import icoclose from './img/ico-close.svg';
import { useNavigate } from 'react-router-dom';
//import useSongSearch from './useSongSearch';
import { toast } from 'react-toastify';
import DanmuTextCard from './DanmuTextCard';

import strings from './strings.js'

const API_URL = "https://www.starboxkod.com/api";

const SelectingQuotaCard = ({ onClick, selectingQuotaTable, selectingQuotaIndex, selectingQuotaNumber, lang, mode, stateTables}  ) => {


    
    const [selectingKey, setSelectingKey] = useState(selectingQuotaNumber);
    const [quota, setQuota] = useState(selectingQuotaNumber);
  
    const [msgTimes, setMsgTimes] = useState(1);
    const [msgPosition, setMsgPosition] = useState(0); //0top 1mid 2low

    const [codeTable, setCodeTable] = useState();

    const [codeError, setCodeError] = useState("");

    const navigate = useNavigate()
    return (
<>
    <div className="LMAOselecting">
        <div className="mui-overlay"
        onClick={(e) => {e.preventDefault(); /* onClick() */}}
        ></div>


        <div className="actions-sheet2" onClick={(e) => {e.preventDefault(); e.stopPropagation(); e.nativeEvent.stopImmediatePropagation();}}>
        
        <div className="quotaCardRow" /* Title for Quota */>
            {mode === 1 &&
                //QUOTA
                <>
                    {selectingQuotaTable?.toUpperCase?.()}: {lang ? strings.cn.quotaMessage : strings.en.quotaMessage}
                </>
            }
            
            {mode === 2 && (lang ? strings.cn.codeMessage : strings.en.codeMessage)}

            {mode === 3 && (lang ? strings.cn.msgMessage : strings.en.msgMessage)}

            {mode === 4 && (lang ? strings.cn.intervalMessage : strings.en.intervalMessage)}

            {mode === 5 && (lang ? strings.cn.clearMessage : strings.en.clearMessage)}

            {mode === 6 && (lang ? strings.cn.keyMessage : strings.en.keyMessage)}


            {/* this is for the add position */}
            {mode === 7 && <>
                {selectingQuotaTable?.toUpperCase?.()}: {lang ? strings.cn.allMessage: strings.en.allMessage}
            </>  }

        </div>

        {mode !== 5 && mode!== 6 ? (
        <div className="quotaCardRow">
            <div className="quotaCardInput">
                <input className="quotaCardInputActual"
                            inputMode={mode === 3 ? "text" : "numeric"}
                            type={mode === 3 ? "text" : "number"}
                            pattern={mode === 3 ? undefined : "[0-9]*"}
                            placeholder=""
                            value={quota}
                            onChange={(e) => setQuota(mode === 3 ? e.target.value : parseInt(e.target.value))}
                        />
                <div className="quotaCardInputClose" onClick={(e)=> {e.preventDefault(); setQuota("");}}>
                        <img src={icoclose}/>
                </div>
            </div>
        </div>) :
        (
            <>
            <div>&nbsp;</div>
            </>
        )
        }



{mode === 6 && (

    <>
    <div className="add-song-container">
                        <a className="ActionPanelnorec-btn"
                        onClick={(e) => {e.preventDefault(); {(selectingKey==-6?setSelectingKey(selectingKey):setSelectingKey(selectingKey -1))}}}
                        style={{color: selectingKey==-6?"#7f7f7f":"#3751fe" ,marginLeft: "0px"}}
                    >
                        ▼&#xFE0E;
                    </a>
                    <a className="ActionPanelmid-btn"
                        onClick={(e) => {e.preventDefault();}}
                    >
                        {(selectingKey<1?"":"+")}{selectingKey}
                    </a>   
                    <a className="ActionPanelrec-btn"
                        onClick={(e) => {e.preventDefault(); {(selectingKey==6?setSelectingKey(selectingKey):setSelectingKey(selectingKey +1))}}}
                        style={{color: selectingKey==6?"#7f7f7f":"#3751fe" }}
                    >
                        ▲&#xFE0E;
                    </a>   
                    </div>
    </>
)


}



{mode === 2 && (
<>
<div className="quotaCardRow" /* Title for Quota */>
{lang ? strings.cn.enterTableMessage : strings.en.enterTableMessage}
</div>
        <div className="quotaCardRow">
            <div className="quotaCardInput" style={{marginBottom: "2vh"}}>
                <input className="quotaCardInputActual"
                            inputMode={mode === 3 ? "text" : "numeric"}
                            type={mode === 3 ? "text" : "number"}
                            pattern={mode === 3 ? undefined : "[0-9]*"}
                            placeholder=""
                            value={codeTable}
                            onChange={(e) => setCodeTable(mode === 3 ? e.target.value : parseInt(e.target.value))}
                        />
                <div className="quotaCardInputClose" onClick={(e)=> {e.preventDefault(); setCodeTable("");}}>
                        <img src={icoclose}/>
                </div>
            </div>
        </div>

        <div className="quotaCardRow" style={{marginBottom:"10px", color:"red"}}/* Title for Quota */>
        &nbsp;{codeError}
        </div>

    </>
)}




{mode === 3 && (
    <>
    <div style={{minHeight:'20vh', maxHeight:'20vh', overflowY:'auto'}}>
    <div className="danmuImageContainer" style={{ display: "inline", gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px', overflowX: 'auto' }}>
        {localStorage.getItem("msg") ? (
        JSON.parse(localStorage.getItem("msg")).map((text, index) => (
            <DanmuTextCard mode={2} key={index} index={index} text={text} setQuota={setQuota} onClick={() => { }} />
        ))
        ) : (
       <></>
        )}
    </div>
    </div>

    <div style={{display:'flex',marginRight:'20px',marginBottom:'30px'}}>
        <a className="ActionPanelnorec-btn" style={{color: msgPosition===0?"#3751fe":"#7f7f7f", fontWeight: msgPosition === 0 ? "bold" : "normal"  }} onClick={(e) => {console.log(msgPosition);e.preventDefault(); setMsgPosition(0);}}>{lang ? strings.cn.top : strings.en.top}</a>
        <a className="ActionPanelmid-btn" style={{color: msgPosition===1?"#3751fe":"#7f7f7f", fontWeight: msgPosition === 1 ? "bold" : "normal"  }} onClick={(e) => {e.preventDefault(); setMsgPosition(1);}}>{lang ? strings.cn.mid : strings.en.mid}</a>
        <a className="ActionPanelrec-btn" style={{color: msgPosition===2?"#3751fe":"#7f7f7f", fontWeight: msgPosition === 2 ? "bold" : "normal"  }} onClick={(e) => {e.preventDefault(); setMsgPosition(2);}}>{lang ? strings.cn.low : strings.en.low}</a>
    </div>
    <div style={{display:'flex',marginRight:'20px',marginBottom:'30px'}}>
        <a className="ActionPanelnorec-btn" style={{color: msgTimes==1?"#3751fe":"#7f7f7f", fontWeight: msgTimes === 1 ? "bold" : "normal"  }} onClick={(e) => {console.log(msgTimes);e.preventDefault(); setMsgTimes(1);}}>1</a>
        <a className="ActionPanelmid-btn" style={{color: msgTimes===5?"#3751fe":"#7f7f7f", fontWeight: msgTimes === 5 ? "bold" : "normal"  }} onClick={(e) => {e.preventDefault(); setMsgTimes(5);}}>5</a>
        <a className="ActionPanelrec-btn" style={{color: msgTimes===99?"#3751fe":"#7f7f7f", fontWeight: msgTimes === 99 ? "bold" : "normal"  }} onClick={(e) => {e.preventDefault(); setMsgTimes(99);}}>99</a>
    </div>
    </>
)}


{mode === 7 && (
    <div style={{display:'flex',marginRight:'20px',marginBottom:'30px'}}>
        <a className="ActionPanelnorec-btn" style={{color: msgTimes==1?"#3751fe":"#7f7f7f", fontWeight: msgTimes === 1 ? "bold" : "normal"  }} onClick={(e) => {console.log(msgTimes);e.preventDefault(); setMsgTimes(1);}}>{lang ? "删除" : "Delete"}</a>
        <a className="ActionPanelmid-btn" style={{color: msgTimes===5?"#3751fe":"#7f7f7f", fontWeight: msgTimes === 5 ? "bold" : "normal"  }} onClick={(e) => {e.preventDefault(); setMsgTimes(5);}}>{lang ? "复制" : "Copy"}</a>
        <a className="ActionPanelrec-btn" style={{color: msgTimes===99?"#3751fe":"#7f7f7f", fontWeight: msgTimes === 99 ? "bold" : "normal"  }} onClick={(e) => {e.preventDefault(); setMsgTimes(99);}}>{lang ? "移动" : "Move"}</a>
        
    </div>
)}


<div className="quotaCardRow">
    <div className="quotaCardBackButton" onClick={(e) => {e.preventDefault(); onClick();}}><img src={icobackblue} style={{width: "20px", height: "20px"}}/></div>
    
 
    



    <div className="quotaCardOkButton" onClick={(e)=>{e.preventDefault();
        if (mode === 1) {
            //QUOTA
            if (isNaN(quota) || quota === "" || quota < 1 || quota > 99) {return;}
            SendMessage(`[{"type":"HALL_SET_QUOTA","tableId":"${selectingQuotaTable}","quota":${quota}}]`);
            onClick();
        }
        else if (mode === 2) {
            //CODE

            if (isNaN(codeTable) || codeTable === "") {
                //ifTableNo is left empty, initiate Code Check
                if (![67, 76, 11, 22, 6789, 9876, 519666, 666519, 28, 82, 1, 2, 4567, 7654, 5678, 8765].includes(quota)) {
                    lang ? setCodeError("编号不存在") : setCodeError("Code does not exist")
                    return;
                }
                //check if valid code then send
                SendMessage(`[{"type":"HALL_CODE","code":${quota}}]`);
                onClick();
            }
            else {
                //tableNo is filled, initiate SongCode Check
                if (stateTables.hasOwnProperty("t"+codeTable)) {
                    //tableNo exists
                    if (!stateTables["t"+codeTable].locked) {
                        //table not locked
                        if (quota) {
                            fetch(`https://starboxkod.com/api/song/[${quota}]`)
                                .then(response => response.json())
                                .then(data => {
                                    if (data.length > 0) {
                                        // Quota exists, use the JSON data
                                        console.log(data);
                                        SendMessage(`[{"type":"TABLE_CLIENT_ADD_SONG", "tableId":"t${codeTable}", "userId":${JSON.parse(localStorage.getItem("sn"))}, "songcode":"${quota}", "vocal":false, "musicKey":0, "rec":false, "song_name":"${data[0].song_name}", "singer":"${data[0].singer}", "language":"${data[0].language}", "audio_track":${data[0].audio_track}, "server_id":"${data[0].server_id}", "rel_path":"${data[0].rel_path}"}]`);
                                        onClick();
                                        toast.success(lang?strings.cn.addSongSuccess:strings.en.addSongSuccess, {
                                            position: "top-center",
                                            autoClose: 1000,
                                            hideProgressBar: true,
                                            closeOnClick: true,
                                            pauseOnHover: false,
                                            draggable: true,
                                            progress: undefined,
                                            theme: "light",
                                            icon: false,
                                            });
                                    } else {
                                        // Quota does not exist
                                        setCodeError(lang?strings.cn.codeNotExistError:strings.en.codeNotExistError)
                                    }
                                })
                                .catch(error => {
                                    console.error('Error fetching quota:', error);
                                });
                        } else {
                            setCodeError(lang?strings.cn.emptyCodeError:strings.en.emptyCodeError)

                        }
                        
                    }
                    else {
                        //print table number locked
                        setCodeError(lang?strings.cn.roomLockedError:strings.en.roomLockedError)
                    }
                }
                else {
                    //print table number does not exist

                    setCodeError(lang?strings.cn.roomNotExistError:strings.en.roomNotExistError)
                }

                
            }
        } else if (mode === 3) {
            //MSG
            if ( quota === undefined  || quota === "") {return;}
            //SendMessage(`[{"type":"HALL_MESSAGE","msg":"${quota}","count":${msgTimes}}]`);
            
            SendMessage(`[{"type":"HALL_MESSAGE","msg":"${quota}","count":${msgTimes},"pos":${msgPosition}}]`);
            onClick();
        } else if (mode === 4) {
            //INTERVAL
            if (isNaN(quota) || quota === "" || quota < 1 || quota > 999) {return;}
            SendMessage(`[{"type":"HALL_SET_INTERVAL","interval":${quota}}]`);
            onClick();
        } else if (mode === 5) {
            //CLEAR
            SendMessage(`[{"type":"HALL_CLEAR"}]`);
            onClick();
        } else if (mode === 6) {
            //CHANGE KEY
            SendMessage(`[{"type":"HALL_KEY_SONG","tableId":"${selectingQuotaTable}","index":${selectingQuotaIndex},"musicKey":${selectingKey}}]`);
            onClick();
        } else if (mode === 7) {
            //CHANGE TABLE PROPERTIES
            if (msgTimes === 1) {
                if (isNaN(quota) || quota === "") {
                    SendMessage(`[{"type":"HALL_DELETE_TABLE","tableId":"${selectingQuotaTable}"}]`)
                    onClick();
                }
            } else if (msgTimes === 5) {
                if (isNaN(quota) || quota === "") {console.log("empty");return;}
                if (("t"+quota) === selectingQuotaTable) {console.log("same");return;}
                if (stateTables.hasOwnProperty("t"+quota)) {
                    //tableNo exists
                    if (!stateTables["t"+quota].locked) {
                        //table not locked 
                        SendMessage(`[{"type":"HALL_COPY_TABLE","tableId":"${selectingQuotaTable}","newTableId":"t${quota}"}]`);
                        onClick();
                    } else {
                        console.log("table locked");
                        return;
                    }
                } else {
                    //tableNo does not exist
                    console.log("table does not exist");
                    return;
                }

                
            } else if (msgTimes === 99) {
                if (isNaN(quota) || quota === "") {console.log("empty");return;}
                if (("t"+quota) === selectingQuotaTable) {console.log("same");return;}
                if (stateTables.hasOwnProperty("t"+quota)) {
                    //tableNo exists
                    if (!stateTables["t"+quota].locked) {
                        //table not locked 
                        SendMessage(`[{"type":"HALL_MOVE_TABLE","tableId":"${selectingQuotaTable}","newTableId":"t${quota}"}]`);
                        onClick();
                    } else {
                        console.log("table locked");
                        return;
                    }
                } else {
                    //tableNo does not exist
                    console.log("table does not exist");
                    return;
                }

            }
        }
        

        }}>
    {lang ? strings.cn.confirm : strings.en.confirm}</div>

    {mode === 3 && 
                            <div className="quotaCardOkButton" onClick={(e)=>{e.preventDefault();
                                SendMessage(`[{"type":"MSG_CANCEL","pos":${msgPosition}}]`);
                                onClick();
                            }} > {lang ? "取消" : "Cancel"}</div>
                            } 



    </div>

                               

        </div>
    </div>
        </>
    );
}

export default SelectingQuotaCard;